import { gql } from '@apollo/client';

export default class LeadMutate {
    static SAVE_LEAD = gql`
        mutation saveLead($conversationId: ID!) {
            saveLead(conversationId: $conversationId)
        }
    `;
}
